



































































































































































































































































































import Vue from 'vue';
import _ from 'lodash';
import moment from 'moment-timezone';

import Requester from '../../requester';

import { ResultadoDeExame } from '../../../../back/src/entity/ResultadoDeExame';
import { StatusExame, DppFinal, ItemExameResultado } from '../../../../back/src/types';
import { calculoIdadeGestacional } from '../../utils/functions';
import { statusExameStrings } from '../../utils/constants';
import { Exame } from '../../../../back/src/entity/Exame';
import { Paciente } from '../../../../back/src/entity/Paciente';
import { Gestacao } from '../../../../back/src/entity/Gestacao';
import { GrupoExame } from '../../../../back/src/entity/GrupoExame';

import CustomDialog from '../CustomDialog.vue';
import ResultadosDeExamesDetalhes from './ResultadosDeExamesDetalhes.vue';
import ResultadosDeExamesFormEdit from './ResultadosDeExamesFormEdit.vue';
import ResultadosDeExamesFormRemover from './ResultadosDeExamesFormRemover.vue';

export default Vue.extend({
  name: 'ResultadosDeExamesTabela',
  components: {
    CustomDialog,
    ResultadosDeExamesDetalhes,
    ResultadosDeExamesFormEdit,
    ResultadosDeExamesFormRemover,
  },
  props: {
    exames: {
      type: Array as () => Exame[],
    },
    resultadosDeExames: {
      type: Array as () => ResultadoDeExame[],
    },
    gruposExames: {
      type: Array as () => GrupoExame[],
    },
    paciente: {
      type: Object as () => Paciente,
    },
    gestacao: {
      type: Object as () => Gestacao,
    },
  },
  data() {
    return {
      dialogDetalhes: false,
      loadingTable: false,
      statusExameStrings,
      StatusExame,
      filterGrupoExame: null,
      formFilterExame: '',
      showPorData: true,
      showSemResultados: false,
      resultadoSelecionado: {} as ResultadoDeExame,
      editResultado: false,
      removeResultado: false,
      trimestres: {
        0: {
          text: this.gestacao ? 'Pré' : 'Data',
          datasLength: 0,
        },
        1: {
          text: '1.o Trimestre',
          datasLength: 0,
        },
        2: {
          text: '2.o Trimestre',
          datasLength: 0,
        },
        3: {
          text: '3.o Trimestre',
          datasLength: 0,
        },
      },
    };
  },
  computed: {
    itemsGruposExames(): { value: number | undefined, text: string }[] {
      return _.map(
        _.orderBy(this.gruposExames as GrupoExame[], ['nome']),
        grupoExame => ({ value: grupoExame.id, text: grupoExame.nome }),
      );
    },
    resultadosDeExamesGestacao(): ResultadoDeExame[] {
      return _.sortBy(
        _.filter(
          this.resultadosDeExames as ResultadoDeExame[],
          (resultado) => {
            if (this.gestacao) {
              return !!resultado.data_exame
                && resultado.gestacao_id === this.gestacao.id
                && resultado.status !== StatusExame.S;
            }
            return !!resultado.data_exame
              && !resultado.gestacao_id
              && resultado.status !== StatusExame.S;
          },
        ),
        resultado => (resultado.data_exame),
      );
    },
    resultadosDeExamesGestacaoOutros(): ResultadoDeExame[] {
      return _.filter(
        this.resultadosDeExamesGestacao as ResultadoDeExame[],
        resultado => (!resultado.exame_id),
      );
    },
    dppFinal(): moment.Moment | null {
      if (!this.gestacao) {
        return null;
      }
      if (this.gestacao.dpp_final === DppFinal.M) {
        if (!this.gestacao.data_ultima_menstruacao) {
          return null;
        }
        const momentDate = moment(this.gestacao.data_ultima_menstruacao).add(40, 'w');
        if (!momentDate.isValid()) {
          return null;
        }
        return momentDate;
      }
      if (this.gestacao.dpp_final === DppFinal.U) {
        if (!this.gestacao.data_provavel_parto_us) {
          return null;
        }
        const momentDate = moment(this.gestacao.data_provavel_parto_us);
        if (!momentDate.isValid()) {
          return null;
        }
        return momentDate;
      }
      return null;
    },
    momentDataFertilizacao(): moment.Moment | null {
      if (this.dppFinal === null) {
        return null;
      }
      return moment(this.dppFinal).subtract(40, 'w');
    },
    momentTrimestre1(): moment.Moment | null {
      if (this.momentDataFertilizacao === null) {
        return null;
      }
      return moment(this.momentDataFertilizacao).add(12, 'w');
    },
    momentTrimestre2(): moment.Moment | null {
      if (this.momentDataFertilizacao === null) {
        return null;
      }
      return moment(this.momentDataFertilizacao).add(28, 'w');
    },
    momentTrimestre3(): moment.Moment | null {
      if (this.momentDataFertilizacao === null) {
        return null;
      }
      return moment(this.momentDataFertilizacao).add(42, 'w');
    },
    trimestresComputed() {
      const trimestresComputed = this.trimestres;
      for (let i = 0; i <= 3; i += 1) {
        const datasTrimestre = _.filter(
          this.datasResultados as string[],
          dataResultado => (this.calculaTrimestre(dataResultado) === i),
        );
        trimestresComputed[i].datasLength = _.size(datasTrimestre);
      }
      return trimestresComputed;
    },
    datasResultados() {
      return _.uniq(_.map(
        this.resultadosDeExamesGestacao as ResultadoDeExame[],
        resultado => (moment(resultado.data_exame || undefined).format('YYYY-MM-DD')),
      ));
    },
    examesTodos(): { id: number, nome: string, grupoExameId: number | null }[] {
      const examesTodos = _.map(
        _.orderBy(
          this.exames as Exame[],
          ['grupo_exame_id', 'ordem'],
        ) as Exame[],
        exame => ({ id: exame.id || 0, nome: exame.nome, grupoExameId: exame.grupo_exame_id }),
      ) as { id: number, nome: string, grupoExameId: number | null }[];
      // Adiciona outros
      let fakeId = -1;
      _.forEach(
        _.uniq(_.map(
          _.sortBy(
            this.resultadosDeExamesGestacaoOutros as ResultadoDeExame[],
            resultado => resultado.nome_exame,
          ),
          resultado => (resultado.nome_exame),
        )),
        (nomeExame) => {
          if (nomeExame) {
            examesTodos.push({ id: fakeId, nome: nomeExame, grupoExameId: null });
            fakeId -= 1;
          }
        },
      );
      return examesTodos;
    },
    examesResultados() {
      // examesResultados
      const examesResultados = [] as ItemExameResultado[];
      _.forEach(
        this.examesTodos as { id: number, nome: string, grupoExameId: number | null }[],
        (exame) => {
          // Resultados por data
          const resultadosData = {};
          let sizeData = 0;
          _.forEach(this.datasResultados as string[], (data) => {
            resultadosData[data] = _.filter(
              this.resultadosDeExamesGestacao as ResultadoDeExame[],
              resultado => (
                moment(resultado.data_exame || undefined).format('YYYY-MM-DD') === data
                && (
                  resultado.exame_id
                    ? resultado.exame_id === exame.id
                    : resultado.nome_exame === exame.nome
                )
              ),
            );
            sizeData += resultadosData[data].length;
          });
          // Resultados por trimestre
          const resultadosTrimestre = {};
          for (let i = 0; i <= 3; i += 1) {
            resultadosTrimestre[i] = _.filter(
              this.resultadosDeExamesGestacao as ResultadoDeExame[],
              resultado => (
                this.calculaTrimestre(resultado.data_exame) === i
                && (
                  resultado.exame_id
                    ? resultado.exame_id === exame.id
                    : resultado.nome_exame === exame.nome
                )
              ),
            );
          }
          // Monta objeto
          examesResultados.push({
            id: exame.id,
            nome: exame.nome,
            grupoExameId: exame.grupoExameId,
            resultadosData,
            resultadosTrimestre,
            sizeData,
          });
        },
      );
      return examesResultados;
    },
  },
  methods: {
    atualizaResultadoDeExame(resultadoDeExame: ResultadoDeExame): void {
      this.resultadoSelecionado = resultadoDeExame;
      this.editResultado = false;
      this.$emit('atualizaResultadoDeExame', resultadoDeExame);
    },
    removeResultadoDeExame(resultadoDeExame: ResultadoDeExame): void {
      this.resultadoSelecionado = resultadoDeExame;
      this.removeResultado = false;
      this.$emit('removeResultadoDeExame', resultadoDeExame);
      this.dialogDetalhes = false;
    },
    detalhesResultado(resultado: ResultadoDeExame): void {
      this.resultadoSelecionado = resultado;
      this.dialogDetalhes = true;
    },
    showItem(item: ItemExameResultado): boolean {
      if (this.filterGrupoExame && item.grupoExameId !== this.filterGrupoExame) {
        return false;
      }
      if (this.formFilterExame) {
        if (this.showSemResultados || item.sizeData > 0) {
          const string = _.deburr(_.toLower(item.nome));
          const substring = _.deburr(_.toLower(this.formFilterExame));
          return string.indexOf(substring) !== -1;
        }
      }
      return this.showSemResultados || item.sizeData > 0;
    },
    idadeGestacional(dataExame: Date) {
      return calculoIdadeGestacional(
        this.gestacao,
        dataExame,
      );
    },
    calculaTrimestre(dataExame: Date): number | null {
      if (!this.gestacao) {
        return 0;
      }
      const momentDataExame = moment(dataExame);
      if (!momentDataExame.isValid()
        || !this.momentDataFertilizacao
        || !this.momentTrimestre1
        || !this.momentTrimestre2
        || !this.momentTrimestre3
      ) {
        return null;
      }
      if (momentDataExame.isBefore(this.momentDataFertilizacao)) {
        return 0;
      }
      if (momentDataExame.isBetween(
        this.momentDataFertilizacao, this.momentTrimestre1, undefined, '[]',
      )) {
        return 1;
      }
      if (momentDataExame.isBetween(
        this.momentTrimestre1, this.momentTrimestre2, undefined, '(]',
      )) {
        return 2;
      }
      if (momentDataExame.isAfter(this.momentTrimestre2)) {
        return 3;
      }
      return null;
    },
    classDataTd(dataExame: string) {
      const index = _.findIndex(
        this.datasResultados as string[],
        data => data === dataExame,
      );
      return this.classDataTh(index);
    },
    classDataTh(index: number): string[] {
      const classData = ['text-center'];
      if (index < 0) {
        return classData;
      }
      let length = 0;
      for (let i = 0; i <= 3; i += 1) {
        if (this.trimestres[i].datasLength > 0) {
          if (index === length) {
            classData.push('borderLeft');
          }
          length += this.trimestres[i].datasLength;
        }
      }
      return classData;
    },
    classStatus(resultado: ResultadoDeExame) {
      if (resultado.status === StatusExame.N || resultado.status === StatusExame['-']) {
        return 'success lighten-4';
      }
      if (resultado.status === StatusExame.A || resultado.status === StatusExame['+']) {
        return 'error lighten-4';
      }
      if (resultado.status === StatusExame.I) {
        return 'primary lighten-4';
      }
      if (_.has(resultado, 'exame') && !!resultado.exame) {
        if (_.has(resultado.exame, 'opcoes_status') && !!resultado.exame.opcoes_status) {
          const opcao = _.find(
            resultado.exame.opcoes_status,
            item => (item.status === resultado.status),
          );
          if (opcao) {
            return `${opcao.color} lighten-4`;
          }
          return 'primary lighten-4';
        }
        return 'success lighten-4';
      }
      if (resultado.status === 'Alterado') {
        return 'error lighten-4';
      }
      return 'success lighten-4';
    },
    getStatus(resultado: ResultadoDeExame) {
      if (resultado.status && _.has(statusExameStrings, resultado.status)) {
        return statusExameStrings[resultado.status];
      }
      return resultado.status;
    },
  },
});
